<template>
  <div>
    <div ref="gMap" id="google_map" class="title" />
    <point-handler v-if="markerDialog" v-model="markerDialog" :point="point" />
    <position-error-handler v-if="openModelPositionError" v-model="openModelPositionError" />
  </div>
</template>

<script>
import googleMap from "@/mixins/googleMap"
import { Loader } from "@googlemaps/js-api-loader"
import PointHandler from "./handler/PointHandler.vue"
import PositionErrorHandler from "@/components/handler/PositionErrorHandler.vue"

export default {
  name: "user-map",
  components: {
    PointHandler,
    PositionErrorHandler,
  },

  data() {
    return {
      markerDialog: false,
      map: null,
      google: null,
      markersObjects: [],
      point: {},
      bounds: null,
      openModelPositionError: false,
    }
  },
  mixins: [googleMap],
  computed: {
    lang() {
      return this.$i18n.locale
    },
    points() {
      return this.$store.getters.pointsInRadius
    },
    pointChosen() {
      return this.$store.getters.point
    },
    myPoint() {
      return this.$store.getters.myPoint
    },
    areas() {
      return this.$store.getters.areas
    },
  },
  watch: {
    points(arr) {
      this.removeMarkers()
      this.markersAll(arr)
      this.markerChosen()
    },
  },
  methods: {
    markerChosen() {
      const pointChosenMarker = this.markersObjects.find(
        (m) => m?._id === this?.pointChosen?._id
      )
      if (pointChosenMarker) {
        this.setRadiusCircle(pointChosenMarker)
      }
    },
    makeLabelInMap(point, position) {
      new window.MapLabel({
        text: point.title,
        position: point?.label?.position || position,
        map: this.map,
        fontSize: point?.label?.fontSize || 25,
        strokeWeight: point?.label?.strokeWeight || 4,
        strokeColor: point?.label?.strokeColor || "#000",
        align: point?.label?.align || "center",
        fontColor: point?.label?.fontColor || "#FFFFFF",
      })
    },
    createPolygons(arr) {
      arr?.forEach((polygon) => {
        let bounds = new this.google.maps.LatLngBounds()
        const paths = polygon.location?.coordinates[0].map((p) => {
          const latLng = new this.google.maps.LatLng(p[1], p[0])
          bounds.extend(latLng)
          return latLng
        })
        this.makeLabelInMap(polygon, bounds.getCenter())
        const myPolygon = new this.google.maps.Polygon({
          paths,
          clickable: false,
          strokeColor: polygon.color,
          strokeOpacity: 0.8,
          strokeWeight: 3,
          fillColor: polygon.color,
          fillOpacity: 0.35,
        })
        myPolygon.setMap(this.map)
        this.$store.commit("area/update", {
          ...polygon,
          polygonData: myPolygon,
        })
      })
    },
    markersAll(arr) {
      const arrInMyPoint = [...arr, this.$store.getters.myPoint]
      arrInMyPoint.forEach((item) => {
        this.markersObjects.push(this.appendMarker(item))
      })
    },
    appendMarker({ _id, icon, type, name, location: { coordinates } }) {
      if (!this.google) return
      let marker = new this.google.maps.Marker({
        position: {
          lat: parseFloat(coordinates[0]),
          lng: parseFloat(coordinates[1]),
        },
        animation:
          type === "myLocation" ? this.google.maps.Animation.DROP : null,
        icon: icon ? icon : "/assets/markerGreen.png",
        label: {
          text: `${name}`,
          fontSize: "12px",
          fontWeight: "normal",
          className: "label-marker",
        },
        type: type === "myLocation" ? "myLocation" : "",
        _id: _id,
        map: this.map,
      })
      marker.addListener(
        "click",
        type === "myLocation" ? () => { } : this.openPoint
      )
      return marker
    },
    openPoint(e) {
      this.findMarkerByCoords(e.latLng.lat(), e.latLng.lng())
      this.markerDialog = true
    },
    findMarkerByCoords(lat, lng) {
      this.isNew = false
      this.point = this.points.find((m) => {
        const [thisLat, thisLng] = m.location.coordinates
        return thisLat === lat && thisLng === lng
      })
    },
    removeMarkers() {
      // this.markersObjects = this.markersObjects.filter(m => m)
      this.markersObjects.forEach((m) => m?.setMap(null))
    },
    handleMapClick(e) {
      this.openAddMarkerDialog({ lat: e.latLng.lat(), lng: e.latLng.lng() })
    },
    focusLocation(e) {
      this.openAddMarkerDialog({ lat: e.latLng.lat(), lng: e.latLng.lng() })
    },
    async loadMap() {
      const loaderOptions = {
        apiKey: process.env.VUE_APP_GOOGLE_API_KEY,
        append: false,
        version: "weekly",
        language: this.$i18n.locale === "he" ? "iw" : "en",
        libraries: ["drawing", "places", "geometry"],
      }
      const mapOptions = {
        center: {
          lat: 31.771959,
          lng: 35.217018,
        },
        fullscreenControl: false,
        zoom: 8,
      }
      const loader = new Loader(loaderOptions)
      await loader.load()

      this.google = window.google
      this.map = new this.google.maps.Map(this.$refs.gMap, mapOptions)
      window.googleMap = this.map
      // const ctaLayer = new this.google.maps.KmlLayer({
      //   url: 'https://mabat.clap.co.il/areas.kmz',
      //   map: this.map,
      // })
      // console.log(ctaLayer)
    },
    async areasLoader() {
      if (this.areas.length) {
        this.createPolygons(this.areas)
      }
    },
  },
  async mounted() {
    await this.loadMap()
    const { isFromHistory } = this.$route.params
    await this.$loadScript(
      "https://cdn.rawgit.com/googlemaps/js-map-label/gh-pages/src/maplabel.js"
    )
    await this.areasLoader()
    if (isFromHistory) {
      await this.setMeToLocation(this.pointChosen)
    } else {
      await this.setMyLocation()
      if (this.myPoint) {
        await this.getPointsInRadius(this.myPoint)
      }
    }
  },
}
</script>
<style lang="scss" scoped>
#google_map {
  width: 100vw;
  height: 82vh;
}

::v-deep .label-marker {
  top: 0;
  right: -50px;
  padding: 5px;
  background-color: aliceblue;
  border-radius: 20%;
  border: solid 1px var(--gold);
  margin: 0 0 100px 0;
}

.title {
  border-radius: 15px 15px 0px 0px !important;
  background-color: white !important;
}
</style>
